/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const trackTagBindModelSchema = z.object({
    "id": z.number().int().describe("Идентификатор"),
"name": z.string().describe("Наименование")
    })